import apiFetch from '../../apiFetch'

export default function (purchaseId, comment, token, lastAccessDate) {
  // TODO review endPoint and delete Todo
  return apiFetch({ endPoint: `dossier/purchase/${purchaseId}/reject`, method: 'PUT', body: comment, token: token, lastAccessDate })
}
